module.exports = __webpack_public_path__ + "static/media/downloadEmployeeDetailsIcon.b7736cb2.svg";